import React from 'react';

import ButtonLink from '@/components/common/ButtonLink/ButtonLink';
import ToggleOptionTitle from '@/components/common/ToggleOption/ToggleOptionTitle';
import styles from './custom-toggle-title.module.scss';


interface ICustomToggleTitleComponentProps {
  title: string;
  isPaused: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export default function CustomToggleTitleComponent({
  title,
  isPaused,
  onClick,
  disabled
}: ICustomToggleTitleComponentProps) {
  return (
    <>
      <ToggleOptionTitle>{title}</ToggleOptionTitle>

      {isPaused && (
        <ButtonLink
          style={{ marginLeft: 10 }}
          onClick={onClick}
        >
          {!disabled &&
            <div className={styles['edit-isPaused-btn']}>
              Edit
            </div>
          }
        </ButtonLink>
      )}
    </>
  );
}
